import * as Yup from "yup";
import {
  GenderTypeEnum,
  GovtIdProofEnum,
  MaritalStatusEnum,
} from "../../../shared/utils/enum";
import { User } from "./User.type";
import { validationMessages } from "../../../shared/utils/validationMessages";

export const StaffPersonalDetailsValidationSchema = Yup.object({
  firstName: Yup.string()
    .required(validationMessages.required("First Name"))
    .min(2, validationMessages.minLength("First Name", 2)),
  lastName: Yup.string()
    .required(validationMessages.required("Last Name"))
    .min(2, validationMessages.minLength("Last Name", 2)),
  dateOfBirth: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Invalid date format")
    .required(validationMessages.required("Date Of Birth"))
    .max(new Date(), validationMessages.pastDate("Date of Birth")),
  gender: Yup.string()
    .required(validationMessages.required("Gender"))
    .oneOf(Object.values(GenderTypeEnum), validationMessages.invalid("Gender")),
  maritalStatus: Yup.string()
    .required(validationMessages.required("Marital Status"))
    .oneOf(
      Object.values(MaritalStatusEnum),
      validationMessages.invalid("Marital Status")
    ),
  govtIdProof: Yup.string()
    .required(validationMessages.required("Govt. Id Proof"))
    .oneOf(
      Object.values(GovtIdProofEnum),
      validationMessages.invalid("Govt. Id Proof")
    ),
  idProofNumber: Yup.string().when("govtIdProof", (govtIdProof, schema) => {
    return govtIdProof
      ? schema.required(validationMessages.required("Id Proof Number"))
      : schema.notRequired();
  }),
});

export const StaffContactDetailsValidationSchema = Yup.object({
  email: Yup.string().email(validationMessages.invalid("Email")),
  mobileNumber: Yup.string()
    .required(validationMessages.required("Mobile Number"))
    .matches(/^[0-9]{10}$/, validationMessages.invalid("Mobile Number"))
    .min(10, validationMessages.minLength("Mobile Number", 10))
    .max(10, validationMessages.maxLength("Mobile Number", 10)),
  address: Yup.string()
    .required(validationMessages.required("Address"))
    .min(5, validationMessages.minLength("Address", 5))
    .max(100, validationMessages.maxLength("Address", 200))
    .matches(/^[a-zA-Z0-9\s,'-]*$/, validationMessages.invalid("Address")),
});

export const validateUserDetails = (values: any, step: number) => {
  const errorMessages = {
    personalDetails: {} as Record<string, string>,
    contactDetails: {} as Record<string, string>,
  };

  if (step === 0 || step === -1) {
    try {
      StaffPersonalDetailsValidationSchema.validateSync(values, {
        abortEarly: false,
      });
    } catch (validationErrors: any) {
      validationErrors.inner.forEach((error: any) => {
        errorMessages.personalDetails[error.path] = error.message;
      });
    }
  }
  if (step === 1 || step === -1) {
    try {
      StaffContactDetailsValidationSchema.validateSync(values, {
        abortEarly: false,
      });
    } catch (validationErrors: any) {
      validationErrors.inner.forEach((error: any) => {
        errorMessages.contactDetails[error.path] = error.message;
      });
    }
  }
  return errorMessages;
};

export const validateUserField = (
  section: string,
  field: string,
  value: any
) => {
  let schema;

  if (section === "personalDetails") {
    schema = StaffPersonalDetailsValidationSchema;
  } else if (section === "contactDetails") {
    schema = StaffContactDetailsValidationSchema;
  }

  if (schema) {
    try {
      schema.validateSyncAt(field, { [field]: value });
      return "";
    } catch (error: any) {
      return error.message;
    }
  }
};

export const validateContactDetails = (userData: User) => {
  try {
    StaffContactDetailsValidationSchema.validateSync(userData, {
      abortEarly: false,
    });
  } catch (error: any) {
    return error;
  }
};

export const validatePersonalDetails = (userData: User) => {
  try {
    StaffPersonalDetailsValidationSchema.validateSync(userData, {
      abortEarly: false,
    });
  } catch (error: any) {
    return error;
  }
};
